import { useState, useEffect } from 'react';
import { useTelegram } from '@/contexts/TelegramContext';

export const useDevice = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  const { isTelegram } = useTelegram();

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      const touch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      
      setIsMobile(width <= 768);
      setIsTouchDevice(touch);
    };

    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  // На мобильных и в Telegram WebApp отключаем drag&drop
  const shouldDisableDragDrop = isMobile || isTelegram || isTouchDevice;

  return { isMobile, isTouchDevice, isTelegram, shouldDisableDragDrop };
};